import ReactECharts from 'echarts-for-react';

interface BarChartProps {
  data: Array<{ label: string; value: number; color?: string }>;
  height?: number;
  horizontal?: boolean;
  barColor?: string;
  formatValue?: (v: number) => string;
}

export function BarChart({ data, height = 260, horizontal = false, barColor = '#6366f1', formatValue }: BarChartProps) {
  const catAxis: any = {
    type: 'category', data: data.map(d => d.label),
    axisLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 10, rotate: horizontal ? 0 : 30 },
    axisLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
  };
  const valAxis: any = {
    type: 'value',
    axisLabel: { color: 'rgba(255,255,255,0.4)', fontSize: 10 },
    splitLine: { lineStyle: { color: 'rgba(255,255,255,0.05)' } },
  };

  const option = {
    tooltip: { trigger: 'axis', backgroundColor: 'rgba(30,30,40,0.95)', borderColor: 'rgba(255,255,255,0.1)', textStyle: { color: '#e5e5e5' } },
    grid: { left: horizontal ? 80 : 45, right: 16, top: 12, bottom: 30 },
    xAxis: horizontal ? valAxis : catAxis,
    yAxis: horizontal ? catAxis : valAxis,
    series: [{
      type: 'bar',
      data: data.map(d => ({ value: d.value, itemStyle: d.color ? { color: d.color } : undefined })),
      barWidth: '55%',
      itemStyle: { color: barColor, borderRadius: horizontal ? [0, 4, 4, 0] : [4, 4, 0, 0] },
      label: formatValue ? { show: true, position: horizontal ? 'right' : 'top', formatter: (p: any) => formatValue(p.value), fontSize: 10, color: 'rgba(255,255,255,0.5)' } : undefined,
    }],
  };

  return <ReactECharts option={option} style={{ height }} notMerge lazyUpdate />;
}
